// extracted by mini-css-extract-plugin
export var item = "examples-item-module--item--R74Ff";
export var content = "examples-item-module--content--Kez9S";
export var title = "examples-item-module--title--hbT5s";
export var description = "examples-item-module--description--XRMuD";
export var techListTitle = "examples-item-module--tech-list-title--qHp-b";
export var imgView = "examples-item-module--img-view--Ix8sg";
export var imgWrapper = "examples-item-module--img-wrapper--Scitw";
export var imgBackgroundColor = "examples-item-module--img-background-color--3Uc9m";
export var img = "examples-item-module--img--XihHB";